export const ERROR_SET_STATUS = 'Something went wrong, not able to set the status'
